<template>
  <l-dialog
    :show="show"
    :isbtn="false"
    :ischa="true"
    @cancel="close()"
    class="teamMHRSP"
    :title="scaleInfo.title"
  >
    <div class="tBox">
      <div
        ref="bar"
        id="bar"
        v-show="false"
        style="height:300px; width: 500px;"
      ></div>
      <div class="left" ref="minBox">
        <h3>一、心理体检概况</h3>
        <p>本报告为心理健康评估结果分析，选用小学生心理健康评定量表(MHRSP)。
          从八个方面全方位的对心理健康进行筛查，根据测评结果数据，
          将测试者的心理健康状态划分为两个水平，即: 有障碍、无障碍。</p>

        <h4>1.1 心理体检人员基本信息</h4>
        <p>参加此次心理体检的人员共{{jcxx.sum}}人，其中男性{{jcxx.sex_nan}}人，女性{{jcxx.sex_nv}}人。
          年龄区间为{{jcxx.age_qj}}岁，平均年龄为{{jcxx.age_ave}}岁，标准差为{{jcxx.age_bzc}}。</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>男</td>
            <td>女</td>
            <td>总数</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.sex_nan}}</td>
            <td>{{jcxx.sex_nv}}</td>
            <td>{{jcxx.sum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.sex_nan|percentage(jcxx.sum)}}</td>
            <td>{{jcxx.sex_nv|percentage(jcxx.sum)}}</td>
            <td>100%</td>
          </tr>
        </table>
        <img
          :src="jcxx.base64_sex"
          alt=""
        >

        <h4>1.2 心理测验简介 </h4>
        <p>《小学生心理健康评定量表》(MHRSP)是由心理学工作者和小学教师协同研发出来的，该量表能够对小学生心理健康状态进行测评,
          对筛选、诊断小学生的心理健康问题有一定的成效。量表由8部分组成，共80个题目，每10个项目组成一个分量表，
          它们分别用英文字母A、B、C、D、E、F、G、H表示。其中A为学习障碍；B为情绪障碍；C为性格缺陷；D为社会适应障碍；
          E为品德缺陷；F为不良习惯；G为行为障碍；H为特种障碍，综合评定小学生心理健康，探讨小学生学习适应性、情绪稳定性、
          社会适应性及行为习惯等方面。该量表来源于陈永胜（2000）编写的《小学生心理健康丛——为小学生心理诊断》。该量表没有编制智力测验的项目内容，
          在运用该量表对小学生进行心理健康测试时，需要结合其他智力测验共同进行。</p>
        <p>心理健康是个体的心理活动处于正常状态，即认知正常，情感协调，意志健全，个性完整和适应良好，能够充分发挥自身的最大潜能，
          以适应生活、学习、工作和社会环境的发展与变化的需要。小学生的心理健康问题主要集中在厌学，与同学、家长、教师关系紧张，情绪波动较大，
          容易被激怒等。该量表能够对小学生心理健康状态的情况进行测评。</p>
        <p>综合评定小学生心理健康,探讨小学生学习适应性、情绪稳定性、社会适应性及行为习惯等方面。</p>

        <h3>二、心理健康评估数据分析报告 </h3>
        <h4>2.1 参试人员整体效度分布</h4>
        <p>根据个人测评数据结果提示，目前有{{jcxx.yxDataSum}}人测试结果有效，{{jcxx.wxDataSum}}人测试结果无效</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>测试结果有效</td>
            <td>测试结果无效</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.yxDataSum}}</td>
            <td>{{jcxx.wxDataSum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.yxDataSum|percentage(jcxx.yxDataSum+jcxx.wxDataSum)}}</td>
            <td>{{jcxx.wxDataSum|percentage(jcxx.yxDataSum+jcxx.wxDataSum)}}</td>
          </tr>
        </table>

        <h4>2.2 参试人员整体心理健康状况分布</h4>
        <p>根据个人测评数据结果提示，目前有{{jcxx.jkDataSum}}人处于心理健康水平，{{jcxx.bjkDataSum}}人的心理体检数据显示有心理问题倾向</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>健康</td>
            <!-- <td>欠佳</td> -->
            <td>不健康</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.jkDataSum}}</td>
            <!-- <td>{{jcxx.qqDataSum}}</td> -->
            <td>{{jcxx.bjkDataSum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.jkDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td>
            <!-- <td>{{jcxx.qqDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td> -->
            <td>{{jcxx.bjkDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td>
          </tr>
        </table>
        <img
          :src="jcxx.base64_jk"
          alt=""
        >

        <h4>2.3 参试人员各因子健康状况分布</h4>
        <p>表中列出参试人员MHRSP八因子较高、较低的人数分布与百分比。
          图中画出八因子各状况人数分布，并较详细的描述各因子的症状表现</p>
        <table cellspacing="0">
          <tr>
            <td
              colspan="2"
              rowspan="2"
            >因子</td>
            <td colspan="2">较高</td>
            <!-- <td colspan="2">中等</td> -->
            <td colspan="2">较低</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>百分比</td>
            <!-- <td>人数</td>
            <td>百分比</td> -->
            <td>人数</td>
            <td>百分比</td>
          </tr>
          <tr
            v-for="item of yzjkxxArr"
            :key="item.name"
          >
            <td colspan="2">{{ item.name }}</td>
            <td>{{item.data1}}</td>
            <td>{{item.data1|percentage(item.data1 + item.data2 + item.data3)}}</td>
            <!-- <td>{{item.data2}}</td>
            <td>{{item.data2|percentage(item.data1 + item.data2 + item.data3)}}</td> -->
            <td>{{item.data3}}</td>
            <td>{{item.data3|percentage(item.data1 + item.data2 + item.data3)}}</td>
          </tr>
        </table>

        <p>学习障碍因子是指在接受教育过程中，个体在特定的学习领域出现障碍或困难。常见的学习障碍包括阅读障碍（如诵读障碍、阅读理解障碍）、写作障碍、计算障碍和语言表达障碍（如语言发展迟缓）等。
          如下图中，测试结果显示：{{yzjkxx.data_1xx.data1}}人有一定程度的学习障碍；
          {{yzjkxx.data_1xx.data3}}人无明显的学习障碍。</p>
        <img
          :src="yzjkxx.data_1xx.base64"
          alt=""
        >

        <p>情绪障碍因子是指个体在情绪调节和表达方面出现困难或异常，影响其日常生活、社交关系和心理健康。常见的情绪障碍包括抑郁症、焦虑症、双相情感障碍、强迫症和创伤后应激障碍等。
          如下图中，测试结果显示：{{yzjkxx.data_2qx.data1}}人有一定程度的情绪障碍；
          {{yzjkxx.data_2qx.data3}}人无明显的情绪障碍。</p>
        <img
          :src="yzjkxx.data_2qx.base64"
          alt=""
        >

        <p>性格缺陷因子是指一个人不稳定的态度，是个人成长形成的人格习惯中的组成部分。一般把一个人遇事不能表现出稳定的态度，所表现出来的不同于常人的反应称为性格缺陷。形成原因有很多，有基因问题、后天经历等。
          如下图中，测试结果显示：{{yzjkxx.data_3xg.data1}}人有一定程度的性格缺陷；
          {{yzjkxx.data_3xg.data3}}人无明显的性格缺陷。</p>
        <img
          :src="yzjkxx.data_3xg.base64"
          alt=""
        >

        <p>社会适应障碍因子是指个体在社交互动、人际关系和适应新环境方面出现困难。这种困难可能会对其日常生活、学业、职业和心理健康产生负面影响。
          如下图中，测试结果显示：{{yzjkxx.data_4sh.data1}}人有一定程度的社会适应障碍；
          {{yzjkxx.data_4sh.data3}}人无明显的社会适应障碍。</p>
        <img
          :src="yzjkxx.data_4sh.base64"
          alt=""
        >

        <p>品德缺陷因子是指一个人在道德和伦理方面的缺陷或不足，表现为行为不端、缺乏责任感、缺乏诚信等。
          如下图中，测试结果显示：{{yzjkxx.data_5pd.data1}}人有一定程度的品德缺陷；
          {{yzjkxx.data_5pd.data3}}人无明显的品德缺陷。</p>
        <img
          :src="yzjkxx.data_5pd.base64"
          alt=""
        >

        <p>不良习惯因子是指人们在日常生活中形成的不利于身心健康、社交关系或个人发展的习惯。
          如下图中，测试结果显示：{{yzjkxx.data_6bl.data1}}人有一定程度的不良习惯；
          {{yzjkxx.data_6bl.data3}}人无明显的不良习惯。</p>
        <img
          :src="yzjkxx.data_6bl.base64"
          alt=""
        >

        <p>行为障碍因子表现为长期以来出现的不适应或违反社会规范的行为。
          如下图中，测试结果显示：{{yzjkxx.data_7xw.data1}}人有一定程度的行为障碍；
          {{yzjkxx.data_7xw.data3}}人无明显的行为障碍。</p>
        <img
          :src="yzjkxx.data_7xw.base64"
          alt=""
        >

        <p>特种障碍因子是指排泄障碍、言语障碍、睡眠障碍、进食障碍等。
          如下图中，测试结果显示：{{yzjkxx.data_8tz.data1}}人有一定程度的特种障碍；
          {{yzjkxx.data_8tz.data3}}人无明显的特种障碍。</p>
        <img
          :src="yzjkxx.data_8tz.base64"
          alt=""
        >

        <h3>三、总结与分析 </h3>
        <p>参加心理健康测评的人员共{{jcxx.sum}}人。根据测评数据统计结果发现，{{jcxx.jkDataSum|percentage(jcxx.sum)}}的人目前处于心理健康水平，
          {{(jcxx.bjkDataSum+jcxx.qqDataSum)|percentage(jcxx.sum)}}的人心理健康状况不佳。</p>
        <p>对于有心理问题倾向的人群，给予重点关注并开展相关心理工作非常重要。心理问题可以涉及各种不同的情绪和行为障碍，如焦虑、抑郁、压力过大等。</p>
        <p>
          以下是一些建议：①早期识别和筛查：提高公众对心理健康问题的认知，鼓励人们主动寻求帮助。通过普及心理健康知识，推广心理测评工具等方式，
          促进早期发现和识别有心理问题倾向的人群。②心理咨询和治疗：提供专业心理咨询和治疗服务，包括个体咨询、心理治疗和心理教育。
          这些服务应该由经过专业培训和资质认证的心理健康专业人士提供。③社会支持网络：建立支持性社交网络，鼓励人们互相支持和分享心理健康经验。组织互助小组、心理健康教育活动等，
          为人们提供一个安全、理解和支持的环境。④提供心理健康教育：开展心理健康教育活动，提高人们对心理问题的认知和理解，减少心理健康问题的社会歧视和偏见。
          ⑤心理健康政策和法律保障：制定和完善相关的心理健康政策和法律法规，保障有心理问题倾向的人群的权益，促进相关心理工作的开展。
        </p>
        <p>
          重点关注和针对性地开展相关心理工作，有助于提高人们的心理健康水平，减少心理问题的发生和发展。这需要社会各个层面的合作与共同努力，包括个人、家庭、学校、医疗机构等等。
        </p>

      </div>
      <div class="right">
        <p class="tit">—— 团体测评 ——</p>
        <p>
          发布人：
          <span>{{scaleInfo.publisherName}}</span>
        </p>
        <p>
          测评人数：
          <span>{{scaleInfo.planTotalPeople}}</span>
        </p>
        <div class="btn">
          <l-button
            value="删除"
            color="#3170FF"
            @click.native="deleteF()"
          ></l-button>
          <l-button
            value="导出"
            color="#FF500C"
            @click.native="exportWord1()"
          ></l-button>
          <l-button
            value="关闭"
            @click.native="close()"
          ></l-button>
        </div>
      </div>
    </div>
  </l-dialog>
</template>

<script>
require("../../../../utils/export/jquery.wordexport");
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import exportWord from '@/utils/export/exportWord'
export default {
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
  },
  mixins: [ exportWord ],
  data () {
    return {
      bar: null,
      scaleInfo: {
        title: '',
        publisherName: '',
        planTotalPeople: '',
      },

      jcxx: {
        sum: 0, // 总人数
        sex_nan: 0, // 男
        sex_nv: 0, // 女
        age_qj: '0-100', // 年龄区间
        age_ave: '0', // 平均年龄
        age_bzc: '0', // 标准差
        base64_sex: '', // 男女比例图
        testSum: 100, // 测试题目数量
        yxDataSum: 0, // 结果有效
        wxDataSum: 0, // 结果无效
        jkDataSum: 0, // 健康人数
        qqDataSum: 0, // 欠佳
        bjkDataSum: 0, // 不健康人数
        base64_jk: '', // 健康状态图
      },

      yzjkxx: {
        data_1xx: {
          name: '学习障碍',
          data1: 0, // 较高
          data2: 0, // 中等
          data3: 0, // 较低
          base64: '',
        },
        data_2qx: {
          name: '情绪障碍',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        },
        data_3xg: {
          name: '性格缺陷',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 孤独倾向
        data_4sh: {
          name: '社会适应障碍',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        },
        data_5pd: {
          name: '品德缺陷',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        },
        data_6bl: {
          name: '不良习惯',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        },
        data_7xw: {
          name: '行为障碍',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        },
        data_8tz: {
          name: '特种障碍',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }
      },
      yzjkxxArr: [],

    };
  },
  props: {
    'show': {
      type: Boolean,
      default: false,
    },
    'publishInfoId': {
      type: [ String, Number ],
      default: '',
    },

  },
  filters: {
    percentage: function (val, sum) {
      if (!val || !sum) return '0%'
      val = +((val / sum) * 100).toFixed(2)
      return val + '%'
    }
  },
  computed: {
  },
  mounted () {
    this.bar = this.echarts.init(this.$refs.bar);
    window.addEventListener("resize", function () {
      this.bar.resize();
    });
  },
  watch: {
    show (val) {
      if (val) {
        this.getData()
      }
    },
    // publishInfoId () {
    //   this.getData()
    // },
  },
  methods: {
    async getData () {
      this.$refs.minBox.scrollTop = 0

      let { data } = await this.$post("api/test/getMHRSPInfoId", {
        publishInfoId: this.publishInfoId,
      });
      console.log(data);
      
      let scaleData = data.data
      this.scaleInfo = {
        title: scaleData.Info.title,
        publisherName: scaleData.Info.publisherName,
        planTotalPeople: scaleData.Info.planTotalPeople.total,
      }

      this.jcxx.sum = scaleData.Info.planTotalPeople.total // 总人数
      this.jcxx.sex_nan = scaleData.Info.planTotalPeople.sex.nan // 男
      this.jcxx.sex_nv = scaleData.Info.planTotalPeople.sex.nv // 女
      this.jcxx.age_qj = scaleData.Info.planTotalPeople.age.min + '-' + scaleData.Info.planTotalPeople.age.max // 年龄区间
      this.jcxx.age_ave = scaleData.Info.planTotalPeople.age.average // 平均年龄
      this.jcxx.age_bzc = scaleData.Info.planTotalPeople.age.Standard // 标准差
      this.jcxx.testSum = scaleData.Info.testSum || this.jcxx.testSum // 测试题目数量
      this.jcxx.yxDataSum = scaleData.Info.valid.data1 // 结果有效
      this.jcxx.wxDataSum = scaleData.Info.valid.data2 // 结果无效
      this.jcxx.jkDataSum = scaleData.Info.healthy.data1 // 健康人数
      // this.jcxx.qqDataSum = scaleData.Info.healthy.data2 // 欠佳
      this.jcxx.bjkDataSum = scaleData.Info.healthy.data2 // 不健康人数

      let nameMap = {
        'one': 'data_1xx', // 学习障碍
        'two': 'data_2qx', // 情绪障碍
        'three': 'data_3xg', // 性格缺陷
        'foru': 'data_4sh', // 社会适应障碍
        'five': 'data_5pd', // 品德缺陷
        'six': 'data_6bl', // 不良习惯
        'seve': 'data_7xw', // 行为障碍
        'eight': 'data_8tz', // 特种障碍
      }
    
      for (let key in scaleData.list) {
        if (key in nameMap) {
          let obj = this.yzjkxx[nameMap[key]],
            dataItem = scaleData.list[key]
          obj.data1 = dataItem.high
          // obj.data2 = dataItem.in
          obj.data3 = dataItem.low
        }
      }

      let yzjkxxArr = []
      for (let key in this.yzjkxx) {
        yzjkxxArr.push(this.yzjkxx[key])
      }
      this.yzjkxxArr = yzjkxxArr

      this.handEcharts()
    },
    //echarts
    handEcharts () {
      this.handEcharts_1()
      this.handEcharts_2()
      this.handEcharts_3()
    },
    handEcharts_1 () {
      let option = {
        animation: false,
        title: {
          text: '参试人员性别统计分布表',
          left: 'center',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'bottom',
        },
        label: {
          formatter: '{b}\n{center|{d}%}',
          fontSize: 14,
          rich: {
            center: {
              lineHeight: 22,
              align: 'center'
            },
          }
        },
        series: [
          {
            name: '参试人员性别统计分布表',
            type: 'pie',
            radius: '60%',
            data: [
              { value: this.jcxx.sex_nan, name: '男' },
              { value: this.jcxx.sex_nv, name: '女' },
            ],
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.bar.setOption(option, { notMerge: true, });
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.jcxx.base64_sex = this.bar.getDataURL(opts); //拿到base64 地址
    },
    handEcharts_2 () {
      let option = {
        animation: false,
        title: {
          text: '参试人员心理健康状态分布表',
          left: 'center',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'bottom',
        },
        label: {
          formatter: '{b}\n{center|{d}%}',
          fontSize: 14,
          rich: {
            center: {
              lineHeight: 22,
              align: 'center'
            },
          }
        },
        series: [
          {
            name: '参试人员心理健康状态分布表',
            type: 'pie',
            radius: '60%',
            data: [
              { value: this.jcxx.jkDataSum, name: '健康', },
              // { value: this.jcxx.qqDataSum, name: '欠佳', },
              { value: this.jcxx.bjkDataSum, name: '不健康', itemStyle: { color: '#fac858' }, },
            ],
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.bar.setOption(option, { notMerge: true, });
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.jcxx.base64_jk = this.bar.getDataURL(opts); //拿到base64 地址
    },
    handEcharts_3 () {
      let hhFoo = (obj) => {
        let option = {
          animation: false,
          title: {
            text: obj.name,
            left: 'center',
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            top: 'bottom',
          },
          label: {
            formatter: '{b}\n{center|{d}%}',
            fontSize: 14,
            rich: {
              center: {
                lineHeight: 22,
                align: 'center'
              },
            }
          },
          series: [
            {
              name: obj.name,
              type: 'pie',
              radius: '60%',
              data: [
                { value: obj.data3, name: '较低' },
                // { value: obj.data2, name: '中等' },
                { value: obj.data1, name: '较高', itemStyle: { color: '#fac858' }, },
              ],
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.bar.setOption(option, { notMerge: true, });
        var opts = {
          //type: "jpeg", // 导出的格式，可选 png, jpeg
          pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
          //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
        };
        obj.base64 = this.bar.getDataURL(opts); //拿到base64 地址
      }

      // yzjkxx: {
      //   data_1xx: {
      //     name: '学习焦虑',
      //     data1: 10, // 较高
      //     data2: 20, // 中等
      //     data3: 30, // 较低
      //     base64: '',
      //   }, // 学习焦虑
      for (let key in this.yzjkxx) {
        let item = this.yzjkxx[key]
        hhFoo(item)
      }

    },
    //导出
    exportWord1 () {
      let data = {
        title: this.scaleInfo.title,
        yzjkxxArr: [],
      }
      for(let key in this.jcxx) {
        data['jcxx.'+key] = this.jcxx[key]
      }
      data['jcxx.sex_nan_bfb'] = percentage(this.jcxx.sex_nan, this.jcxx.sum)
      data['jcxx.sex_nv_bfb'] = percentage(this.jcxx.sex_nv, this.jcxx.sum)
      data['jcxx.yxDataSum_bfb'] = percentage(this.jcxx.yxDataSum, (this.jcxx.yxDataSum+this.jcxx.wxDataSum))
      data['jcxx.wxDataSum_bfb'] = percentage(this.jcxx.wxDataSum, (this.jcxx.yxDataSum+this.jcxx.wxDataSum))
      data['jcxx.jkDataSum_bfb'] = percentage(this.jcxx.jkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.qqDataSum_bfb'] = percentage(this.jcxx.qqDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.bjkDataSum_bfb'] = percentage(this.jcxx.bjkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.jkDataSum_e_bfb'] = percentage(this.jcxx.jkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.bjkDataSum_e_bfb'] = percentage((this.jcxx.bjkDataSum + this.jcxx.qqDataSum), (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      
      for(let key1 in this.yzjkxx) {
        for (let key2 in this.yzjkxx[key1]) {
          data['yzjkxx.'+key1+'.'+key2] = this.yzjkxx[key1][key2]
        }
      }
      for(let item of this.yzjkxxArr) {
        data.yzjkxxArr.push(Object.assign({
          data1_bfb: percentage(item.data1, item.data1 + item.data2 + item.data3),
          data2_bfb: percentage(item.data2, item.data1 + item.data2 + item.data3),
          data3_bfb: percentage(item.data3, item.data1 + item.data2 + item.data3),
        }, item))
      }
      console.log(data)
      this.exportWord('docxTemplate/teamMHRSP.docx', this.scaleInfo.title, data)

      function percentage(val, sum) {
        if (!val || !sum) return '0%'
        val = +((val / sum) * 100).toFixed(2)
        return val + '%'
      }
    },
    // exportWord1 () {
    //   let _this = this;
    //   let pre = this.$refs.minBox.outerHTML;
    //   console.log(pre)
    //   let html = `<div>
    //             <h2 style="text-align:center">《${this.scaleInfo.title}》</h2>
    //             <div style="display:flex">
    //                 <span>发布人：${this.scaleInfo.publisherName}</span>&nbsp;&nbsp; <span>测评人数：${this.scaleInfo.planTotalPeople}</span><br>
    //                 <h4>测试结果</h4>
    //                 ${pre}
    //             </div></div>`;
    //   setTimeout(function () {
    //     $(html).wordExport(_this.scaleInfo.title, []);
    //   }, 1000);
    // },
    deleteF () {
      this.$emit("deleteF")
    },
    close () {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang='less' scoped>
.teamMHRSP /deep/.dialog {
  width: 1000px;
  height: 750px;
}
.tBox {
  display: flex;
  height: 100%;
  background: #fff;
}
.left {
  width: 719px;
  overflow-y: auto;
  border-right: 1px solid #f0f0f0;
  padding: 20px 50px;
  box-sizing: border-box;

  h3 {
    font-size: 24px;
    color: #1298e6;
    padding: 8px 0;
    border-bottom: 1px solid #666;
    margin: 16px 0;
  }
  h4 {
    font-size: 18px;
    color: #07935d;
    margin: 16px 0;
  }
  p {
    text-indent: 2em;
    font-size: 16px;
    line-height: 1.7em;
    margin: 8px 0;
    word-break: break-all;
    text-align: justify;
  }
  img {
    max-width: 100%;
    min-height: 300px;
    margin: 8px 0;
  }

  table {
    width: 100%;
    color: #333;
    font-size: 16px;
    text-align: center;
    border: 1px solid #666;
    margin: 8px 0;
    td {
      height: 40px;
      border: 1px solid #666;
    }
  }
}
.right {
  font-size: 14px;
  width: 280px;
  box-sizing: border-box;
  .tit {
    margin: 39px 0 29px 0;
    text-align: center;
    color: #5f5f5f;
  }
  p {
    margin-left: 30px;
    margin-bottom: 25px;
  }
  span {
    color: #555;
  }
  .btn {
    position: absolute;
    height: 40px;
    line-height: 40px;
    bottom: 50px;
    right: 20px;
    button {
      width: 70px;
      margin: 0 5px;
    }
  }
}
</style>